var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-l border-r lg:border-b col-span-full flex items-center justify-start gap-1 border-ds-outline-secondary p-3 text-base lg:col-span-2"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }